import type { ReturnWorkflowDto, WorkflowV2Dto } from "@babackapp/private-api-client/types";
import useGetAllReturnWorkflows from "@babackapp/private-api-client/client/use-get-all-return-workflows";
import useGetAllWorkflowsV2 from "@babackapp/private-api-client/client/use-get-all-workflows-v2";
import { useTemplatesEditorConfig } from "../context/templates-editor-config-context";
import useCurrentShopSuspense from "./use-current-shop-suspense";

/**
 * Workflows with an action pointing to the template (`send_*_email`,
 * `update_web`). A return template is only sent by return workflows, a
 * tracking one only by tracking workflows.
 */
export default function useTemplateWorkflowsDependencies(templateId?: string | null) {
  const { data: shop } = useCurrentShopSuspense();
  const { domain } = useTemplatesEditorConfig();
  const isReturn = domain === "return";
  const { data: trackingWorkflows } = useGetAllWorkflowsV2(shop.id, { enabled: !isReturn });
  const { data: returnWorkflows } = useGetAllReturnWorkflows(shop.id, { enabled: isReturn });

  if (!templateId) {
    return [];
  }

  const workflows: (WorkflowV2Dto | ReturnWorkflowDto)[] =
    (isReturn ? returnWorkflows : trackingWorkflows) ?? [];

  return workflows.filter((workflow) =>
    workflow.definition.nodes?.some(
      (node) =>
        node.type === "action" &&
        (node.data as { config?: { templateId?: string | null } }).config?.templateId === templateId,
    ),
  );
}
